import { gen2CloudReq } from 'src/services/gen_2_http_reqs';
import { get_sockets_length } from 'src/services/socket';

/**
 * Make a generic RPC call to the device
 * @param device_id The ID of the device
 * @param method The RPC method to call
 * @param paramsObject The parameters to include in the RPC call
 * @returns The response from the device
 * @throws An error if the RPC call fails
 */
export async function sendCamRPC(device_id: string, method: string, paramsObject?: any) {
	if (!get_sockets_length()) {
		// Cloud is still not alive. Backoff and fail.
		await new Promise((resolve) => setTimeout(resolve, 500));
		throw new Error('Awaiting cloud connection...');
	}
	const response = await gen2CloudReq(device_id, 'camera', method, paramsObject, false, 12000);

	if (response?.error) {
		let errorMsg = handleError(response.error);
		throw new Error(errorMsg);
	}

	return response?.data;
}

// Handle known error codes and return user-friendly messages
// @ToDo: Error handling and messages
// @ToDo: Android camera returns error as object, other API returns string
// @ToDo: Handle device error codes
const handleError = (error: string | any) => {
	let errorMsg = error?.error || error || 'Unknown error';
	const errorType = typeof error === 'string' ? error.toUpperCase() : error?.error;
	switch (errorType) {
		case 'WRONG_ID':
			errorMsg = 'Device is offline or not reachable';
			break;
		case 'TIMEOUT':
			errorMsg = 'Device communication timeout';
			break;
		case 'INTERNAL':
			errorMsg = 'Device internal error';
			break;
		case 'JRPC_ERROR':
			let deviceError = error?.device_error;
			errorMsg = handleDeviceError(deviceError);
			break;
		default:
			errorMsg = 'Generic error: ' + errorMsg;
			break;
	}
	throw new Error(errorMsg);
};

// @ToDo: Handle device error codes
const handleDeviceError = (response: any) => {
	switch (response?.code) {
		case 500:
			return 'Received 500: ' + response.message;
		case 504:
			return 'Received 504: ' + response.message;
		default:
			return 'Received ' + response?.code + ': ' + response?.message;
	}
};
